import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RegisterMinuteWithOperationRequest, RegisterMinuteWithOperationsVm } from '../../interface/company-minutes.interface';
import { RegisterMinutesService } from '../../service/register-minutes.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { formatDate } from '@angular/common';
import { RequestBodyMinute } from '../../sub-page/minutes/interface/minute-detail';

@Component({
  selector: 'app-register-minute-with-ops',
  templateUrl: './register-minute-with-ops.component.html',
  styleUrls: ['./register-minute-with-ops.component.scss']
})
export class RegisterMinuteWithOpsComponent implements OnInit {
  public form: FormGroup;
  public columns = [
    'folio',
    'fechaCesion',
    'financedAmount',
    'transferAmount'
  ]
  public warrantyColumns = [
    'warrantyType',
    'insuranceCompany',
    'amount',
    'amountType',
    'cost',
    'requestDate',
    'endDate',
    'insuranceBroker'
  ];

  constructor(
    public dialogRef: MatDialogRef<RegisterMinuteWithOpsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RegisterMinuteWithOperationsVm,
    private formBulder: FormBuilder,
    private registerMinuteService: RegisterMinutesService,
    private router: Router
  ){
    let currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 30);
    this.form = this.formBulder.group({
      companyId: [0],
      description: [''],
      operations: [null],
      warranties: [null],
      factoringLine: [0],
      warrantyLine: [0],
      hasConditions: [false],
      dueDate: [formatDate(currentDate, 'yyyy-MM-dd', 'en'), []]
    });
  }

  ngOnInit(): void {
      this.form.patchValue({
        companyId: this.data.clientCompanyId,
        operations: this.data.operations.map(p => p.invoiceOperationId),
        warranties: this.data.warranties?.map(p => p.warrantyId)
      });
      this.getLines();
  }

  getLines() {
    this.registerMinuteService.getCompanyLines(this.data.clientCompanyId)
    .subscribe({
      next:(res) => {
        this.form.patchValue({
          factoringLine: res.factoringLine,
          warrantyLine: res.warrantyLine
        })
      }
    })
  }

  public closeDialog() {
    this.dialogRef.close();
  }

  public submit(){
    const {companyId, description, operations, dueDate, warrantyLine, factoringLine, warranties, hasConditions} = this.form.value;
    const request: RequestBodyMinute = {
      clientCompanyId: companyId,
      description: description,
      operationIds: operations,
      warrantyLine: warrantyLine,
      line: factoringLine,
      duedate: dueDate,
      warrantiesId: warranties,
      hasConditions: false
    };

    Swal.fire({
      title: 'Generando minuta',
      icon: 'info',
      didOpen: () => {
        Swal.showLoading();
        this.registerMinute(request);
      }
    })
  }

  private registerMinute(request: RequestBodyMinute) {
    this.registerMinuteService.resgiterMinute(request)
    .subscribe({
      next: (response) => {
        Swal.fire({
          title: 'Minuta generada',
          icon: 'success',
          showConfirmButton: true,
          allowOutsideClick: false,
        }).then((r) => {
          if(r.isConfirmed) {
            this.dialogRef.close();
            this.router.navigate(['dashboards/minute'], {
              queryParams: {id: response.value.minuteRequestId}
            });

          }
        })
      },
      error: (err) => {
        Swal.fire({
          title: 'Error',
          text: err.error.resultMessage,
          icon: 'error'
        })
      } 
    });
  }

}
